import React, { useState, useEffect, useRef } from "react";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import "./TreeTable.css";
import CreateBlankModal from "../components/modals/CreateBlankModal";
import { Add, Delete,Info } from "@mui/icons-material";
import apiService from "../utils/api";
import downloadIcon from '../assets/download.svg';
import Snackbar from '@mui/material/Snackbar';
import DeleteConfirmationModal from "../components/modals/DeleteConfirmationModal";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import jspdfAutotable from "jspdf-autotable";
import Breadcrumbs from "../components/Breadcrumbs";
import AddDocumentModal from "../components/modals/AddDocumentModal";
import { useRBAC } from "./rbac/RbacProvider";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";
import { DataTable } from 'primereact/datatable';
import ArchiveEmailTemplate from '../utils/ArchiveEmailTemplate';
import Footer from './Footer';


const TreeTableSample = () => {
  const [tokenReady, setTokenReady] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const accessToken = params.get("access_token");
    const refreshToken = params.get("refresh_token");

    if (accessToken && refreshToken) {
      localStorage.setItem("access_token", accessToken);
      localStorage.setItem("refresh_token", refreshToken);
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    const token = localStorage.getItem("access_token");
    if (!token) {
      console.warn("No access token found, redirecting to login");
      window.location.href = "/login";
      return;
    }

    const fetchUserDetails = async () => {
      try {
        const userRes = await apiService.fetchData("user-details");
        if (userRes?.status === "success" && userRes.user) {
          sessionStorage.setItem("user_id", userRes.user.user_id);
          sessionStorage.setItem(
            "user_role",
            userRes.user.role?.[0]?.RoleName || userRes.user.role || ""
          );
          sessionStorage.setItem("user_name", userRes.user.user_name);
          sessionStorage.setItem("user_emailId", userRes.user.email);
        } else {
          throw new Error("Invalid token");
        }

        // ✅ Once everything is set, mark token ready
        setTokenReady(true);
      } catch (err) {
        console.error("Auth validation failed:", err);
        localStorage.clear();
        window.location.href = "/login";
      }
    };

    fetchUserDetails();
  }, []);

  const { role } = useRBAC();
  const navigate = useNavigate();
  const [filters, setFilters] = useState({ global: "" });
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    node: null,
    contractId: null,

  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [favorites, setFavorites] = useState({});
  const [nodes, setNodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editableNode, setEditableNode] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [contractToDelete, setContractToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, success: false, message: "" });
  const [expandedKeys, setExpandedKeys] = useState({});
  const [isAddDocumentModalOpen, setIsAddDocumentModalOpen] = useState(false);
  const [prefillContractData, setPrefillContractData] = useState(null);
  const [isPrefillLoading, setIsPrefillLoading] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [showColumnOptions, setShowColumnOptions] = useState(false);
  const [isFavoriteLoading, setIsFavoriteLoading] = useState(false);
  const [favoriteNode, setFavoriteNode] = useState(null);
  const [showFlatView, setShowFlatView] = useState(false);
  const [flatData, setFlatData] = useState([]);
  const [clientFilter, setClientFilter] = useState('');
  const [contractTypeFilter, setContractTypeFilter] = useState('');
  const [filteredFlatData, setFilteredFlatData] = useState([]);
  const [nameFilter, setNameFilter] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [filteredNodes, setFilteredNodes] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [contractTypeOptions, setContractTypeOptions] = useState([]);
  const [creationTypeFilter, setCreationTypeFilter] = useState('');
  const [creationTypeOptions, setCreationTypeOptions] = useState([]);
  const [dateFilter, setDateFilter] = useState('');
  const mandatoryColumns = ['name', 'type', 'status'];
  const [currentHierarchyMode, setCurrentHierarchyMode] = useState("default");
  const [switchingHierarchy, setSwitchingHierarchy] = useState(false);
  const [originalHierarchy, setOriginalHierarchy] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState(() => {
    const savedColumns = localStorage.getItem('treeTableVisibleColumns');
    const defaultColumns = {
      name: true,
      type: true,
      startDate: true,
      endDate: true,
      renewalDate: true,
      createdDate: false,
      status: true,
      modified: false,
      actions: true,
      contractType: true,
      creationType: true,
      vendorName: true,
    };
    let cols = savedColumns ? JSON.parse(savedColumns) : defaultColumns;
    mandatoryColumns.forEach(col => {
      if (cols.hasOwnProperty(col)) cols[col] = true;
    });
    return cols;
  });
  const downloadRef = useRef(null);
  const [tempVisibleColumns, setTempVisibleColumns] = useState(visibleColumns);

  const capitalize = (s) => (typeof s === 'string' && s.length > 0) ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s;

  const getUserId = () => {
    return Number(sessionStorage.getItem("user_id")) || null;
  };
  const getUserRole = () => (sessionStorage.getItem("user_role") || "").replace(/\s+/g, '');
  const fullAccessRoles = ['Admin', 'LegalUser', 'LegalReviewer'];
  const hasFullAccess = fullAccessRoles.includes(getUserRole());

  const getAllowedContractIds = () => {
    const email = sessionStorage.getItem("user_emailId") || "";
    if (!email.endsWith('@criticalriver.com')) {
      // Hardcoded contract IDs for external users (non-CriticalRiver)
      return ['955','960','961'];
    }
    return null; // null means no filtering (full access)
  };

  const getApiEndpoint = () => {
    const rawRole = sessionStorage.getItem("user_role") || "";
    const role = rawRole.replace(/\s+/g, '');
    const userId = getUserId();


    console.log("Raw role from API:", `"${rawRole}"`);
    console.log("Cleaned role (spaces removed):", `"${role}"`);
    console.log("User ID:", userId);

    if (role === "Admin") {
      console.log("Using Admin endpoint");
      return "all-contracts-hierarchy?is_wip=false";
    }

    if (role === "ClientPartners") {
      console.log("Client Partner detected → Using filtered admin endpoint");
      return `all-contracts-hierarchy?is_wip=false&client_partner=true&partner_id=${userId}`;
    }

    // Default fallback (LegalUser, etc.)
    console.log("Default role → Using contract-hierarchy with user_id");
    return `contract-hierarchy?user_id=${userId}&is_wip=false`;
  };

  // ===== HELPERS FOR FLATTENING NESTING DEPTH (Issues 1-3) =====

  // Helper: Format contract node (lowest level)
  const formatContractNode = (contract, parentClientName) => ({
    key: contract.key,
    data: {
      ...contract.data,
      type: 'File',
      name: contract.data.contract_title || contract.data.name || 'N/A',
      clientName: contract.data.clientName || parentClientName || 'N/A',
      createdDate: contract.data.createdDate || contract.data.created_at || 'N/A',
      status: contract.data.status || 'N/A',
      modified: contract.data.modified || contract.data.updated_at || 'N/A',
      contractType: contract.data.contract_type_name || 'N/A',
      creationType: contract.data.creation_type || 'N/A',
      id: contract.data.id || contract.data.contract_id || 'N/A',
      is_favourite: contract.data.is_favourite || false,
      is_deleted: contract.data.is_deleted || false,
    },
  });

  // Utility: Format date to YYYY-MM-DD format
  const toYMD = (v) => {
    if (!v || v === 'N/A') return v || '';
    try {
      const d = new Date(v);
      if (!isNaN(d.getTime())) return d.toISOString().slice(0, 10);
    } catch (_) { }
    return String(v).slice(0, 10);
  };

  // Utility: Format end/renewal date with auto-renewal check
  const formatEndRenewal = (v) => {
    if (!v || v === 'N/A') return v || '';
    const s = String(v);
    if (s.startsWith('1999-01-01')) return 'Auto renewal';
    return toYMD(s);
  };

  // Utility: Get formatted column label for display
  const getColumnLabel = (key) => {
    const labelMap = {
      name: 'Contract Name',
      clientName: 'Client',
      type: 'Type',
      createdDate: 'Created',
      contractType: 'Contract Type',
      creationType: 'Creation Type',
      actions: 'Actions',
    };
    return labelMap[key] || (key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1'));
  };

  // Helper: Get single column value for node (centralized to reduce complexity)
  const getValueForColumn = (node, key, isFile = true) => {
    // Date-like keys share similar logic; handle them first to simplify branching
    const dateKeys = ['startDate', 'endDate', 'renewalDate'];
    if (dateKeys.includes(key)) {
      if (!isFile) return '';
      const val = node[key];
      if (!val) return '';
      return key === 'startDate' ? toYMD(val) : formatEndRenewal(val);
    }

    const getters = {
      name: (n) => n.displayName || '',
      type: (n) => n.entityType || 'Client',
      createdDate: (n) => n.createdDate || '',
      status: (n) => n.status || '',
      modified: (n) => n.modified || '',
    };

    return getters[key] ? getters[key](node) : '';
  };

  // Helper: Build flat row as object for Excel export
  const buildFlatRowObject = (item, visibleColumns) => {
    const row = {};
    if (visibleColumns.name) row['Contract Name'] = item.name || "";
    if (visibleColumns.type) row['Type'] = item.type || "";
    if (visibleColumns.vendorName) row['Vendor'] = item.vendorName || "N/A";
    if (visibleColumns.startDate) row['Start Date'] = item.startDate ? toYMD(item.startDate) : "";
    if (visibleColumns.endDate) row['End Date'] = formatEndRenewal(item.endDate || "");
    if (visibleColumns.renewalDate) row['Renewal Date'] = formatEndRenewal(item.renewalDate || "");
    if (visibleColumns.createdDate) row['Created'] = item.createdDate || "";
    if (visibleColumns.status) row['Status'] = item.status || "";
    if (visibleColumns.modified) row['Modified'] = item.modified || "";
    if (visibleColumns.contractType) row['Contract Type'] = item.contractType || "N/A";
    if (visibleColumns.creationType) row['Creation Type'] = item.creationType || "N/A";
    return row;
  };

  // Helper: Build flat row as array for PDF export
  const buildFlatRowArray = (item, visibleColumns) => {
    const row = [];
    if (visibleColumns.name) row.push(item.name || "");
    if (visibleColumns.type) row.push(item.type || "");
    if (visibleColumns.vendorName) row.push(item.vendorName || "N/A");
    if (visibleColumns.startDate) row.push(item.startDate ? toYMD(item.startDate) : "");
    if (visibleColumns.endDate) row.push(formatEndRenewal(item.endDate || ""));
    if (visibleColumns.renewalDate) row.push(formatEndRenewal(item.renewalDate || ""));
    if (visibleColumns.createdDate) row.push(item.createdDate || "");
    if (visibleColumns.status) row.push(item.status || "");
    if (visibleColumns.modified) row.push(item.modified || "");
    if (visibleColumns.contractType) row.push(item.contractType || "N/A");
    if (visibleColumns.creationType) row.push(item.creationType || "N/A");
    return row;
  };

  // Utility: Build row with visible columns for hierarchy node
  const buildRowFromNode = (node, visibleColumns, isFile = true) => {
    const row = {};
    const order = ['name', 'type', 'startDate', 'endDate', 'renewalDate', 'createdDate', 'status', 'modified'];
    const labelMap = {
      name: 'Contract Name',
      type: 'Type',
      startDate: 'Start Date',
      endDate: 'End Date',
      renewalDate: 'Renewal Date',
      createdDate: 'Created',
      status: 'Status',
      modified: 'Modified',
    };

    order.forEach((key) => {
      if (visibleColumns[key]) {
        row[labelMap[key]] = getValueForColumn(node, key, isFile);
      }
    });

    return row;
  };

  // Utility: Build array row with visible columns for hierarchy node
  const buildArrayRowFromNode = (node, visibleColumns, isFile = true) => {
    const row = [];
    const order = ['name', 'type', 'startDate', 'endDate', 'renewalDate', 'createdDate', 'status', 'modified'];
    order.forEach((key) => {
      if (visibleColumns[key]) {
        row.push(getValueForColumn(node, key, isFile));
      }
    });
    return row;
  };

  // Utility: Flatten hierarchy tree to flat structure with formatting
  const flattenHierarchyToObjects = (nodes, visibleColumns, depth = 0, result = []) => {
    nodes.forEach((node) => {
      const indent = '    '.repeat(depth);
      const icon = node.data.type === 'Folder' ? '> ' : node.data.type === 'File' ? '- ' : '';
      const displayName = `${indent}${icon}${node.data.name || ''}`;
      const nodeInfo = {
        displayName,
        entityType: node.data.entity_type ? node.data.entity_type.charAt(0).toUpperCase() + node.data.entity_type.slice(1) : 'Client',
        startDate: node.data.start_date,
        endDate: node.data.end_date,
        renewalDate: node.data.renewal_date,
        createdDate: node.data.createdDate || '',
        status: node.data.status || '',
        modified: node.data.modified || '',
        isFile: node.data.type === 'File',
      };
      const row = buildRowFromNode(nodeInfo, visibleColumns, nodeInfo.isFile);
      result.push(row);
      if (node.children && node.children.length > 0) {
        flattenHierarchyToObjects(node.children, visibleColumns, depth + 1, result);
      }
    });
    return result;
  };

  // Utility: Flatten hierarchy tree to array structure with formatting
  const flattenHierarchyToArrays = (nodes, visibleColumns, depth = 0, result = []) => {
    nodes.forEach((node) => {
      const indent = '    '.repeat(depth);
      const icon = node.data.type === 'Folder' ? '> ' : node.data.type === 'File' ? '- ' : '';
      const displayName = `${indent}${icon}${node.data.name || ''}`;
      const nodeInfo = {
        displayName,
        entityType: node.data.entity_type ? node.data.entity_type.charAt(0).toUpperCase() + node.data.entity_type.slice(1) : 'Client',
        startDate: node.data.start_date,
        endDate: node.data.end_date,
        renewalDate: node.data.renewal_date,
        createdDate: node.data.createdDate || '',
        status: node.data.status || '',
        modified: node.data.modified || '',
        isFile: node.data.type === 'File',
      };
      const row = buildArrayRowFromNode(nodeInfo, visibleColumns, nodeInfo.isFile);
      result.push(row);
      if (node.children && node.children.length > 0) {
        flattenHierarchyToArrays(node.children, visibleColumns, depth + 1, result);
      }
    });
    return result;
  };

  // Helper: Recursively process folder/parent nodes
  const processNodeRecursive = (node, parentClientName) => {
    const data = {
      ...node.data,
      type: node.data.type === 'File' ? 'File' : 'Folder',
      name: node.data.name || 'N/A',
      clientName: node.data.clientName || parentClientName || 'N/A',
      createdDate: node.data.createdDate || 'N/A',
      status: node.data.status || 'N/A',
      modified: node.data.modified || 'N/A',
      contractType: node.data.contract_type_name || 'N/A',
      creationType: node.data.creation_type || 'N/A',
    };
    if (node.data.type === 'File' || !node.children) {
      return { key: node.key, data };
    }
    const children = node.children.map(child => processNodeRecursive(child, parentClientName));
    return { key: node.key, data, children };
  };

  // Helper: Format contract type node
  const formatContractTypeNode = (type, clientName) => ({
    key: type.key,
    data: {
      ...type.data,
      type: 'Folder',
      name: type.data.name || type.data.contract_type_name || 'N/A',
      clientName: type.data.clientName || clientName || 'N/A',
      createdDate: type.data.createdDate || 'N/A',
      status: type.data.status || 'N/A',
      modified: type.data.modified || 'N/A',
      contractType: type.data.contract_type_name || 'N/A',
      creationType: type.data.creation_type || 'N/A',
    },
    children: type.children.map(parent => processNodeRecursive(parent, clientName)),
  });

  // Helper: Format client node for legal hierarchy
  const formatLegalClientNode = (client) => ({
    key: client.key,
    data: {
      ...client.data,
      type: 'Folder',
      name: client.data.name || client.data.clientName || 'N/A',
      clientName: client.data.clientName || 'N/A',
      createdDate: client.data.createdDate || 'N/A',
      status: client.data.status || 'N/A',
      modified: client.data.modified || 'N/A',
      contractType: client.data.contract_type_name || 'N/A',
      creationType: client.data.creation_type || 'N/A',
    },
    children: client.children.map(parent => {
      const parentData = {
        ...parent.data,
        type: 'Folder',
        name: parent.data.name || 'N/A',
        clientName: parent.data.clientName || client.data.clientName || 'N/A',
        createdDate: parent.data.createdDate || 'N/A',
        status: parent.data.status || 'N/A',
        modified: parent.data.modified || 'N/A',
        contractType: parent.data.contract_type_name || 'N/A',
        creationType: parent.data.creation_type || 'N/A',
      };
      return {
        key: parent.key,
        data: parentData,
        children: parent.children.map(child => processNodeRecursive(child, client.data.clientName)),
      };
    }),
  });

  const parseAdminHierarchy = (hierarchy) => {
    return hierarchy.map(client => ({
      key: client.key,
      data: {
        ...client.data,
        type: 'Folder',
        name: client.data.name || client.data.clientName || 'N/A',
        clientName: client.data.clientName || 'N/A',
        createdDate: client.data.createdDate || 'N/A',
        status: client.data.status || 'N/A',
        modified: client.data.modified || 'N/A',
        contractType: client.data.contract_type_name || 'N/A',
        creationType: client.data.creation_type || 'N/A',
      },
      children: client.children.map(type => formatContractTypeNode(type, client.data.clientName)),
    }));
  };

  const parseLegalHierarchy = (hierarchy) => {
    return hierarchy.map(year => ({
      key: year.key,
      data: {
        ...year.data,
        type: 'Folder',
        name: year.data.name || year.data.year || 'N/A',
        clientName: year.data.clientName || 'N/A',
        createdDate: year.data.createdDate || 'N/A',
        status: year.data.status || 'N/A',
        modified: year.data.modified || 'N/A',
        contractType: year.data.contract_type_name || 'N/A',
        creationType: year.data.creation_type || 'N/A',
      },
      children: year.children.map(client => formatLegalClientNode(client)),
    }));
  };

  // Helper: Recursively propagate clientName down hierarchy tree
  const propagateClientName = (node, clientName) => {
    const data = { ...node.data, clientName };
    if (!node.children || node.children.length === 0) {
      return { key: node.key, data };
    }
    const children = node.children.map(child => propagateClientName(child, clientName));
    return { key: node.key, data, children };
  };

  // Helper: Create a year-child entry for client-first legal hierarchy
  const createYearChild = (year, client, clientName) => {
    return {
      key: `${clientName}-${year.key}`.replace(/\s+/g, ''), // Unique key
      data: {
        ...year.data,
        type: 'Folder',
        name: year.data.name || year.data.year || 'N/A',
        clientName: clientName,
      },
      children: client.children.map((parent) => propagateClientName(parent, clientName)),
    };
  };

  const parseClientFirstLegalHierarchy = (hierarchy) => {
    const clientMap = new Map();

    hierarchy.forEach((year) => {
      year.children.forEach((client) => {
        const clientName = client.data.clientName || client.data.name || 'N/A';
        if (!clientMap.has(clientName)) {
          clientMap.set(clientName, {
            key: client.key.replace(/\s+/g, ''), // Clean key for uniqueness
            data: {
              ...client.data,
              type: 'Folder',
              name: clientName,
            },
            children: [],
          });
        }

        const clientEntry = clientMap.get(clientName);

        const yearChild = createYearChild(year, client, clientName);
        clientEntry.children.push(yearChild);
      });
    });

    return Array.from(clientMap.values());
  };


  const addLevels = (nodes, level = 0) => {
    return nodes
      .filter(node => node.data.type === "File" ? !node.data.is_deleted : true)
      .map(node => ({
        ...node,
        level,
        children: node.children ? addLevels(node.children, level + 1) : [],
      }))
      .filter(node => node.data.type === "File" || node.children.length > 0);
  };
  
  const filterFavorites = (nodes) => {
    if (!window.location.pathname.includes('/favourites')) return nodes;

    const filterNodes = (nodes) => {
      return nodes
        .filter(node => node.data.type === "File" ? node.data.is_favourite : true)
        .map(node => ({
          ...node,
          children: node.children ? filterNodes(node.children) : [],
        }))
        .filter(node => node.data.type === "File" || node.children.length > 0);
    };

    return filterNodes(nodes);
  };


  const fetchData = async () => {
    try {
      setLoading(true);
      const userId = getUserId();
      const allowedContractIds = getAllowedContractIds();

      // ---- Fetch tree hierarchy ----
      const treeEndpoint = getApiEndpoint();
      const treeRes = await apiService.fetchData(treeEndpoint);

      if (treeRes && (treeRes.contract_hierarchy || treeRes.data)) {
        let hierarchy = treeRes.contract_hierarchy || treeRes.data;

        // Sort hierarchy by year (Max to Min)
        hierarchy = [...hierarchy].sort((a, b) => {
          const yearA = parseInt(a.data?.year || a.data?.name) || 0;
          const yearB = parseInt(b.data?.year || b.data?.name) || 0;
          return yearB - yearA;
        });

        setOriginalHierarchy(hierarchy);
        const withLevels = addLevels(hierarchy);

        const filteredDeleted = (nodes) =>
          nodes
            .filter((node) => (node.data.type === "File" ? !node.data.is_deleted : true))
            .map((node) => ({
              ...node,
              children: node.children ? filteredDeleted(node.children) : [],
            }))
            .filter((node) => node.data.type === "File" || node.children.length > 0);

        // Filter by allowed contract IDs for external users
        const filterByAllowedIds = (nodes) => {
          if (!allowedContractIds) return nodes; // No filtering for internal users
          
          return nodes
            .map((node) => {
              if (node.data.type === "File") {
                const contractId = getCleanContractId(node.data.id);
                if (!allowedContractIds.includes(contractId)) {
                  return null; // Filter out this contract
                }
              }
              return {
                ...node,
                children: node.children ? filterByAllowedIds(node.children) : [],
              };
            })
            .filter(Boolean)
            .filter((node) => node.data.type === "File" || node.children.length > 0);
        };

        const filteredNodes = filterFavorites(filterByAllowedIds(filteredDeleted(withLevels)));
        setNodes(filteredNodes);
      }

      // ---- Fetch flat contracts ----
      const flatRes = await apiService.fetchData(`user-flat-contracts?user_id=${userId}&is_wip=false`);
      console.log(" Raw API Response (flatRes):", flatRes);

      if (flatRes && flatRes.status === "success" && Array.isArray(flatRes.data)) {
        let contracts = flatRes.data;
        console.log(" Raw Contracts Data:", contracts);

        // Filter contracts for external users
        if (allowedContractIds) {
          contracts = contracts.filter(item => 
            allowedContractIds.includes(String(item.contract_id))
          );
        }

        const flatDataMapped = contracts.map((item) => ({
          id: `CONTRACT-${item.contract_id}`,
          name: item.contract_title || "N/A",
          clientName: item.client_name || "N/A",
          type: item.client_id === null ? "Vendor" : "Client",
          vendorName: item.client_id === null ? item.party_name || "N/A" : "N/A",
          createdDate: item.created_at ? new Date(item.created_at).toISOString().split("T")[0] : "N/A",
          status: item.status || "N/A",
          modified: item.updated_at ? new Date(item.updated_at).toISOString().split("T")[0] : "N/A",
          startDate: item.start_date || "N/A",
          endDate: (item.end_date && (String(item.end_date) === '1999-01-01' || String(item.end_date).startsWith('1999-01-01'))) ? 'Auto renewal' : (item.end_date || 'N/A'),
          renewalDate: (item.renewal_date && (String(item.renewal_date) === '1999-01-01' || String(item.renewal_date).startsWith('1999-01-01'))) ? 'Auto renewal' : (item.renewal_date || 'N/A'),
          contractType: item.contract_type_name || "N/A",
          creationType: capitalize(item.creation_type) || "N/A",
          clientKey: item.client_id ? `${item.client_name}-${item.client_id}` : "N/A",
        }));

        console.log(" Final flatDataMapped:", flatDataMapped);
        setFlatData(flatDataMapped);
        setFilteredFlatData(flatDataMapped);

        // ---- Derive filter options ----
        const uniqueClients = [...new Set(contracts.map((item) => item.client_name))].filter(Boolean);
        const uniqueContractTypes = [...new Set(contracts.map((item) => item.contract_type_name))].filter(Boolean);
        const uniqueStatuses = [...new Set(contracts.map((item) => item.status))].filter(Boolean);
        const uniqueCreationTypes = [...new Set(contracts.map((item) => item.creation_type))].filter(Boolean);

        setClientOptions(uniqueClients);
        setContractTypeOptions(uniqueContractTypes);
        setStatusOptions(uniqueStatuses);
        setCreationTypeOptions(uniqueCreationTypes.map(capitalize));
      } else {
        throw new Error("Invalid flat contracts response");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setSnackbar({
        open: true,
        success: false,
        message: "Error fetching contract data",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (tokenReady) {
      fetchData();
    }
  }, [tokenReady, role]);

  useEffect(() => {
    localStorage.setItem('treeTableVisibleColumns', JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  useEffect(() => {
    if (showColumnOptions) {
      setTempVisibleColumns(visibleColumns);
    }
  }, [showColumnOptions, visibleColumns]);

  useEffect(() => {
    let filtered = flatData;
    if (clientFilter) {
      filtered = filtered.filter(item => item.clientName.toLowerCase().includes(clientFilter.toLowerCase()));
    }
    if (contractTypeFilter) {
      filtered = filtered.filter(item => item.contractType.toLowerCase().includes(contractTypeFilter.toLowerCase()));
    }
    if (nameFilter) {
      filtered = filtered.filter(item => item.name.toLowerCase().includes(nameFilter.toLowerCase()));
    }
    if (creationTypeFilter) {
      filtered = filtered.filter((item) => item.creationType === creationTypeFilter);
    }
    if (statusFilter) {
      filtered = filtered.filter(item => item.status.toLowerCase().includes(statusFilter.toLowerCase()));
    }
    if (dateFilter) {
      filtered = filtered.filter(item =>
        item.createdDate.toLowerCase().includes(dateFilter.toLowerCase()) ||
        item.modified.toLowerCase().includes(dateFilter.toLowerCase())
      );
    }
    setFilteredFlatData(filtered);
  }, [clientFilter, contractTypeFilter, nameFilter, statusFilter, flatData, dateFilter, creationTypeFilter]);


  useEffect(() => {
    const searchValue = (filters.global || "").toLowerCase().trim();

    if (!searchValue) {
      setFilteredNodes(nodes);
      setFilteredFlatData(flatData);
      return;
    }

    // Filter TreeTable
    const filterTree = (treeNodes) => {
      return treeNodes
        .map(node => {
          const nodeText = Object.values(node.data || {})
            .join(" ")
            .toLowerCase();

          const matches = nodeText.includes(searchValue);
          const filteredChildren = node.children ? filterTree(node.children) : [];

          if (matches || filteredChildren.length > 0) {
            return { ...node, children: filteredChildren };
          }
          return null;
        })
        .filter(Boolean);
    };

    setFilteredNodes(filterTree(nodes));

    // Filter Flat Table
    const filteredFlat = flatData.filter(item =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchValue)
    );
    setFilteredFlatData(filteredFlat);

  }, [filters.global, nodes, flatData]);

  useEffect(() => {
    // Clear search when switching between views
    setFilters({ global: "" });
  }, [showFlatView]);

  const filterTreeNodes = (nodes, term) => {
    return nodes.reduce((acc, node) => {
      const matches = node.data.name.toLowerCase().includes(term.toLowerCase());
      const filteredChildren = filterTreeNodes(node.children || [], term);
      if (matches || filteredChildren.length > 0) {
        acc.push({
          ...node,
          children: filteredChildren,
        });
      }
      return acc;
    }, []);
  };
  useEffect(() => {
    if (searchTerm) {
      const filtered = filterTreeNodes(nodes, searchTerm);
      setFilteredNodes(filtered);
    } else {
      setFilteredNodes([]);
    }
  }, [searchTerm, nodes]);

  useEffect(() => {
    if (showColumnOptions) {
      let temp = { ...visibleColumns };
      mandatoryColumns.forEach(col => {
        if (temp.hasOwnProperty(col)) temp[col] = true;
      });
      setTempVisibleColumns(temp);
    }
  }, [showColumnOptions, visibleColumns]);

  const flattenNodes = (nodes, result = []) => {
    nodes.forEach((node) => {
      if (node.data.type === "File") {
        result.push({
          id: node.data.id,
          name: node.data.name || "N/A",
          clientName: node.data.clientName || "N/A",
          createdDate: node.data.createdDate || "N/A",
          status: node.data.status || "N/A",
          modified: node.data.modified || "N/A",
          contractType: node.data.contract_type_name || "N/A",
          creationType: node.data.creation_type || "N/A",
        });
      }
      if (node.children) flattenNodes(node.children, result);
    });
    return result;
  };

  const handleAddFavourite = async (node) => {
    const contractId = node.data.id;
    const userId = getUserId();
    const newIsFavourite = !node.data.is_favourite;

    let rawContractId = contractId;
    if (rawContractId && rawContractId.includes("CONTRACT-")) {
      rawContractId = rawContractId.replace("CONTRACT-", "");
    } else {
      setSnackbar({ open: true, success: false, message: "Invalid contract ID format" });
      return;
    }

    const payload = {
      user_id: userId,
      contract_id: rawContractId,
    };

    setIsFavoriteLoading(true);
    setFavoriteNode(node);
    try {
      const response = await apiService.postData(
        `favourites?is_favourite=${newIsFavourite}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === "error" || !response.status) {
        setSnackbar({ open: true, success: false, message: response.message || "Failed to update favourite" });
      } else {
        node.data.is_favourite = newIsFavourite;
        setFavorites((prev) => ({
          ...prev,
          [node.key]: newIsFavourite,
        }));
        if (window.location.pathname.includes('/favourites') && !newIsFavourite) {
          setLoading(true);
          await fetchData();
        } else {
          setNodes([...nodes]);
        }
        setSnackbar({
          open: true,
          success: true,
          message: newIsFavourite
            ? "Contract added to favorites"
            : "Contract removed from favorites",
        });
      }
    } catch (error) {
      console.error("Error posting to favorites:", error);
      setSnackbar({ open: true, success: false, message: "Error updating favorite" });
    } finally {
      setIsFavoriteLoading(false);
      setFavoriteNode(null);
    }
  };

  const handleSwitchHierarchy = () => {
    if (!originalHierarchy || originalHierarchy.length === 0) {
      setSnackbar({ open: true, success: false, message: "No hierarchy data available" });
      return;
    }

    setSwitchingHierarchy(true);

    try {
      let processedHierarchy;

      if (currentHierarchyMode === "default") {
        // Switch to Client → Year
        processedHierarchy = swapYearAndClient(originalHierarchy);
        setCurrentHierarchyMode("client-first");
        setSnackbar({ open: true, success: true, message: "Switched to Client → Year view" });
      } else {
        // Switch back to Year → Client
        processedHierarchy = originalHierarchy;
        setCurrentHierarchyMode("default");
        setSnackbar({ open: true, success: true, message: "Switched to Year → Client view" });
      }

      // Apply your existing filters
      const withLevels = addLevels(processedHierarchy);

      const filteredDeleted = (nodes) =>
        nodes
          .filter((node) => (node.data.type === "File" ? !node.data.is_deleted : true))
          .map((node) => ({
            ...node,
            children: node.children ? filteredDeleted(node.children) : [],
          }))
          .filter((node) => node.data.type === "File" || node.children.length > 0);

      const finalNodes = filterFavorites(filteredDeleted(withLevels));
      setNodes(finalNodes);

    } catch (error) {
      console.error("Switch failed:", error);
      setSnackbar({ open: true, success: false, message: "Switch failed" });
    } finally {
      setSwitchingHierarchy(false);
    }
  };

  // Swap Year → Client  to  Client → Year
  const swapYearAndClient = (yearFirstNodes) => {
    const clientMap = new Map();

    yearFirstNodes.forEach((yearNode) => {
      const yearKey = yearNode.key;
      const yearName = yearNode.data.year || yearNode.data.name || "Unknown Year";

      (yearNode.children || []).forEach((clientNode) => {
        // Use the original client name as displayed
        const clientName = clientNode.data.clientName || clientNode.data.name || "Unknown Client";

        // Create a unique, safe key using the full client name (preserve case and spaces)
        // Use the Web Crypto API when available for secure randomness; fall back safely.
        const randomPart = (typeof crypto !== 'undefined' && (crypto.randomUUID || crypto.getRandomValues))
          ? (crypto.randomUUID ? crypto.randomUUID() : Array.from(crypto.getRandomValues(new Uint8Array(8))).map(b => b.toString(16).padStart(2, '0')).join(''))
          : Math.floor(Math.random() * 1e9).toString(16);
        const safeClientKey = `client-${clientName.replace(/[^a-zA-Z0-9]/g, '_')}-${Date.now()}-${randomPart}`;

        // If this client doesn't exist yet, create it
        if (!clientMap.has(clientName)) {
          clientMap.set(clientName, {
            key: safeClientKey,
            data: {
              type: "Folder",
              name: clientName,
              clientName: clientName,
            },
            children: [],
          });
        }

        // Add the year under this client
        const clientEntry = clientMap.get(clientName);
        clientEntry.children.push({
          key: `${safeClientKey}-year-${yearKey}`,
          data: {
            type: "Folder",
            name: yearName,
          },
          children: clientNode.children || [],
        });
      });
    });

    // Return all clients in the order they were first encountered
    return Array.from(clientMap.values());
  };

  const exportToExcel = () => {
    let rows = [];

    // Define headers based on visibleColumns and view
    const headerMap = {
      name: "Contract Name",
      type: "Type",
      vendorName: "Vendor",
      startDate: "Start Date",
      endDate: "End Date",
      renewalDate: "Renewal Date",
      createdDate: "Created",
      status: "Status",
      modified: "Modified",
      contractType: "Contract Type",
      creationType: "Creation Type",
    };

    if (showFlatView) {
      // For flat view, use filteredFlatData with visible columns (utilities at component level)
      rows = filteredFlatData.map((item) => buildFlatRowObject(item, visibleColumns));
    } else {
      // For tree view, use flattened hierarchy with visible columns
      const treeData =
        filteredNodes.length > 0
          ? filteredNodes
          : filters.global
            ? filterTreeNodes(nodes, filters.global)
            : nodes;

      rows = flattenHierarchyToObjects(treeData, visibleColumns);
    }

    if (rows.length === 0) {
      setSnackbar({
        open: true,
        success: false,
        message: "No data available to download",
      });
      setShowDownloadMenu(false);
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Contracts");
    XLSX.writeFile(workbook, "contracts.xlsx");
    setShowDownloadMenu(false);
  };


  const exportToPDF = () => {
    const doc = new jsPDF();
    let head = [];
    let rows = [];
    const headerMap = {
      name: "Contract Name",
      type: "Type",
      vendorName: "Vendor",
      startDate: "Start Date",
      endDate: "End Date",
      renewalDate: "Renewal Date",
      createdDate: "Created",
      status: "Status",
      modified: "Modified",
      contractType: "Contract Type",
      creationType: "Creation Type",
    };

    // Filter headers based on visibleColumns
    const visibleHeaders = Object.keys(headerMap)
      .filter((key) => visibleColumns[key] && (showFlatView || ["name", "type", "startDate", "endDate", "renewalDate", "createdDate", "status", "modified"].includes(key)))
      .map((key) => headerMap[key]);

    head = [visibleHeaders];

    if (showFlatView) {
      // For flat view, use filteredFlatData with visible columns (utilities at component level)
      rows = filteredFlatData.map((item) => buildFlatRowArray(item, visibleColumns));
    } else {
      // For tree view, use flattened hierarchy with visible columns
      const treeData =
        filteredNodes.length > 0
          ? filteredNodes
          : filters.global
            ? filterTreeNodes(nodes, filters.global)
            : nodes;

      rows = flattenHierarchyToArrays(treeData, visibleColumns);
    }

    if (rows.length === 0) {
      setSnackbar({
        open: true,
        success: false,
        message: "No data available to download",
      });
      setShowDownloadMenu(false);
      return;
    }

    // Generate the table
    jspdfAutotable(doc, {
      head,
      body: rows,
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [255, 107, 53] }, // Optional header color
      didParseCell: (data) => {
        // Make folder/file icons bold in tree view
        if (!showFlatView && (data.row.raw[0]?.includes("> ") || data.row.raw[0]?.includes("- "))) {
          data.cell.styles.fontStyle = "bold";
        }
      },
    });

    doc.save("contracts_hierarchy.pdf");
    setShowDownloadMenu(false);
  };

  const handleTrash = async (node, reason) => {
    setIsDeleting(true);
    try {
      const rawContractId = getCleanContractId(node.data.id);
      const payload = {
        user_id: getUserId(),
        contract_id: rawContractId,
        reason: reason,
      };

      const response = await apiService.postData("enhanced-trash", payload);
      const result = response.data || response;

      console.log("Archive API Result:", result);

      if (result.status === "success") {
        fetchData();
        const emailData = {
          recipientName: sessionStorage.getItem('user_name') || '',
          contractTitle: node.data.name,
          contractId: node.data.contract_id || rawContractId,
          previousStatus: node.data.status || 'Active',
          userName: sessionStorage.getItem('user_name') || '',
          actionDate: new Date().toISOString().split('T')[0],
          actionReason: reason,
          contractUrl: node.data.file_url || '#',
        };

        const html = ArchiveEmailTemplate(emailData);

        try {
          await apiService.sendEmail(
            sessionStorage.getItem('user_emailId') || '',
            'Contract Moved to Archive',
            html
          );
          console.log('Email sent successfully');
        } catch (emailError) {
          console.error('Failed to send email:', emailError);
          setSnackbar({
            open: true,
            success: false,
            message: 'Contract archived, but email notification failed',
          });
        }
        setSnackbar({
          open: true,
          success: true,
          message: `Contract (ID: ${rawContractId}) moved to archive`,
        });
      } else {
        setSnackbar({
          open: true,
          success: false,
          message: result.message || "Failed to move to archive",
        });
      }
    } catch (error) {
      console.error("Error moving to archive:", error);
      setSnackbar({
        open: true,
        success: false,
        message: "Error moving to archive",
      });
    } finally {
      setIsDeleting(false);
      setIsDeleteModalOpen(false);
    }
  };


  const removeNodeByKey = (nodes, keyToRemove) => {
    const keyParts = keyToRemove.split("-");
    if (keyParts.length === 1) {
      return nodes.filter((node) => node.key !== keyToRemove);
    }
    const newNodes = JSON.parse(JSON.stringify(nodes));
    let currentLevel = newNodes;
    for (let i = 0; i < keyParts.length - 1; i++) {
      const key = keyParts.slice(0, i + 1).join("-");
      const node = currentLevel.find((n) => n.key === key);
      if (!node || !node.children) return newNodes;
      currentLevel = node.children;
    }
    currentLevel.splice(
      currentLevel.findIndex((n) => n.key === keyToRemove),
      1
    );
    return newNodes;
  };

  const globalFilterFunction = (node, filter) => {
    if (!filter) return true;
    const searchLower = filter.toLowerCase();
    return (
      (node.data.name && node.data.name.toLowerCase().includes(searchLower)) ||
      (node.data.clientName && node.data.clientName.toLowerCase().includes(searchLower)) ||
      (node.data.createdDate && node.data.createdDate.toLowerCase().includes(searchLower)) ||
      (node.data.status && node.data.status.toLowerCase().includes(searchLower)) ||
      (node.data.modified && node.data.modified.toLowerCase().includes(searchLower))
    );
  };

  const toggleColumn = (key) => {
    if (mandatoryColumns.includes(key)) return;
    setTempVisibleColumns(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const getCleanContractId = (id) => {
    // Avoid regex to prevent any potential catastrophic backtracking.
    // Extract trailing digits using a simple linear scan from the end.
    try {
      if (id == null) return id;
      const s = typeof id === 'string' ? id : String(id);
      let i = s.length - 1;
      if (i < 0) return s;
      // Move left while characters are digits (0-9)
      while (i >= 0) {
        const code = s.charCodeAt(i);
        if (code < 48 || code > 57) break;
        i--;
      }
      const start = i + 1;
      if (start <= s.length - 1) return s.slice(start);
      return s;
    } catch (e) {
      return id;
    }
  };

  const getClientKey = (nodeKey, rowData = null) => {
    if (rowData && rowData.clientKey && rowData.clientKey !== "N/A") {
      return rowData.clientKey;
    }
    if (rowData?.clientName) {
      const clientId = rowData.clientName.split('-')[1];
      if (clientId) return `CLIENT-${clientId}`;
    }
    const parts = nodeKey.split("-");
    return parts[0];
  };

  // Helper: Find the first File-type (contract) child under a folder node
  const findFirstChildContract = (node) => {
    if (!node || !node.children) return null;
    for (const child of node.children) {
      if (child.data?.type === "File") return child;
      // Recurse into sub-folders
      const found = findFirstChildContract(child);
      if (found) return found;
    }
    return null;
  };

  // Fetch contract details by ID and open the AddDocumentModal with prefilled data
  const handleAddWithPrefill = (folderNode) => {
    // Open the modal instantly
    setModalType("document");
    setIsAddDocumentModalOpen(true);
    setContextMenu({ visible: false, node: folderNode, contractId: null });

    const childContract = findFirstChildContract(folderNode);
    if (childContract) {
      const rawId = getCleanContractId(childContract.data.id);
      setIsPrefillLoading(true);
      setPrefillContractData(null);
      
      apiService.fetchData(`contracts/${rawId}`)
        .then(contractDetails => {
          console.log("Prefill contract details fetched:", contractDetails);
          setPrefillContractData(contractDetails);
          setIsPrefillLoading(false);
        })
        .catch(err => {
          console.error("Error fetching contract details for prefill:", err);
          setPrefillContractData(null);
          setIsPrefillLoading(false);
        });
    } else {
      setPrefillContractData(null);
      setIsPrefillLoading(false);
    }
  };

  return (
    <div className="card" style={{
      minHeight: '100vh',
      paddingBottom: '60px',  // Space for fixed footer
      display: 'flex',
      flexDirection: 'column',
    }}>
      <Breadcrumbs /><br />
      {/* <h3 className="title">Signed Contracts</h3>Professional Page Header */}
      <div style={{
        background: '#fff',
        borderRadius: '8px',
        padding: '24px 28px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
        borderLeft: '4px solid #ff6b35',
        marginBottom: '24px'
      }}>
        <h1 style={{
          fontSize: '24px',
          fontWeight: 700,
          color: '#212529',
          margin: 0,
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <span style={{
            width: '28px',
            height: '28px',
            background: 'linear-gradient(135deg, #ff6b35 0%, #ff8c61 100%)',
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontSize: '16px'
          }}>
            📋
          </span>
          Signed Contracts
        </h1>
      </div>
      <Loader
        isLoading={isFavoriteLoading}
        message={favoriteNode?.data.is_favourite ? "Removing from Favorites" : "Adding to Favorites"}
      />
      <Loader
        isLoading={loading}
        message="Please wait, loading your contracts 🙂"
      />
      {!loading && (
        <>
          <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginBottom: "20px", gap: "10px" }}>
            {!loading && nodes.length === 0 && ["Admin", "LegalReviewer", "LegalUser"].includes(getUserRole()) && (
              <div style={{ display: "flex", alignItems: "center", gap: "6px", color: "#ff6b35", fontWeight: 600 }} title="Click + New to create a contract">
                <span>Create your first contract</span>
                <span style={{ fontSize: "18px" }}>→</span>
              </div>
            )}
            {["Admin", "LegalReviewer", "LegalUser"].includes(getUserRole()) && (
              <button
                onClick={() => {
                  setPrefillContractData(null);
                  setModalType("document");
                  setIsAddDocumentModalOpen(true);
                  setContextMenu({ visible: false, node: null, contractId: null });
                }}
                style={{
                  background: "#ff6b35",
                  color: "white",
                  border: "1px solid #ff6b35",
                  padding: "8px 14px",
                  borderRadius: "6px",
                  fontSize: "0.9rem",
                  cursor: "pointer",
                  boxShadow: "var(--shadow)",
                  fontWeight: "bold",
                }}
              >
                + New
              </button>
            )}
            <button
              className="add-role-button"
              onClick={() => setShowFlatView(!showFlatView)}
              style={{ background: "#ff6b35", color: "white", border: "1px solid #ff6b35", padding: "8px 14px", borderRadius: "6px", fontWeight: "bold" }}
            >
              {showFlatView ? 'Tree View' : 'Table View'}
            </button>
            <button
              onClick={handleSwitchHierarchy}
              disabled={switchingHierarchy}
              style={{
                background: switchingHierarchy ? "#ccc" : "#ff6b35",
                color: "white",
                padding: "8px 14px",
                borderRadius: "6px",
                fontWeight: "bold",
                cursor: switchingHierarchy ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                border: 'none',
              }}
            >
              {switchingHierarchy ? (
                <>Switching...</>
              ) : (
                <>
                  Switch → {currentHierarchyMode === "default" ? "Client First" : "Year First"}
                </>
              )}
            </button>

            <input
              type="text"
              placeholder="Search..."
              value={filters.global || ""}
              onChange={(e) => setFilters({ global: e.target.value })}
              style={{
                padding: "8px",
                width: "170px",
                border: "1px solid #ff6b35",
                borderRadius: "4px",
                marginTop: "10px",
              }}
            />

            <button
              onClick={() => setShowColumnOptions(true)}
              style={{
                cursor: "pointer",
                padding: "4px 12px",
                borderRadius: "6px",
                background: "transparent",
                color: "#4A4A4A",
                border: "1px solid #ff6b35",
                fontSize: "16px",
                fontWeight: 500,
              }}
            >
              ⚙ Column options
            </button>
            <div style={{ position: "relative" }} ref={downloadRef}>
              <button
                onClick={() => setShowDownloadMenu(!showDownloadMenu)}
                style={{
                  cursor: "pointer",
                  padding: "4px 12px",
                  borderRadius: "6px",
                  background: "transparent",
                  border: "1px solid #ff6b35",
                  color: "#4A4A4A",
                  fontSize: "16px",
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <img src={downloadIcon} alt="Download" style={{ width: "16px", height: "20px" }} /> Download
              </button>
              {showDownloadMenu && (
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    marginTop: "6px",
                    borderRadius: "6px",
                    background: "white",
                    border: "1px solid #e5e7eb",
                    zIndex: 10,
                  }}
                >
                  <button
                    onClick={exportToExcel}
                    style={{
                      cursor: "pointer",
                      border: "none",
                      display: "block",
                      padding: "8px 12px",
                      width: "120px",
                      textAlign: "left",
                      background: "none",
                      color: "#4A4A4A",
                    }}
                  >
                    Download CSV
                  </button>
                  <button
                    onClick={exportToPDF}
                    style={{
                      cursor: "pointer",
                      border: "none",
                      display: "block",
                      padding: "8px 12px",
                      width: "120px",
                      textAlign: "left",
                      background: "none",
                      color: "#4A4A4A",
                    }}
                  >
                    Download PDF
                  </button>
                </div>
              )}
            </div>
          </div>
          <div style={{ overflow: "hidden" }}>
            {showFlatView ? (
              <>

                <DataTable value={filteredFlatData} paginator rows={10} rowsPerPageOptions={[5, 10, 20, 50]} tableStyle={{ width: '100%', border: '1px solid #ff6b35' }} emptyMessage={"no contract data available, create a new with clicking on that new button"}>
                  {visibleColumns.name && (
                    <Column
                      field="name"
                      header="Contract Name"
                      body={(rowData) => (
                        <span
                          style={{ cursor: "pointer", color: "#ff6b35" }}
                          onClick={() => {
                            const cleanId = rowData.id.replace("CONTRACT-", "");
                            const clientKey = getClientKey(rowData.id, rowData);
                            navigate("/categories", { state: { contractId: cleanId, clientKey: clientKey, fromDataTable: true } });
                          }}
                          title="Click to open the document"
                        >
                          {rowData.name}
                        </span>
                      )}
                    />
                  )}
                  {visibleColumns.type && (
                    <Column
                      field="type"
                      header="Type"
                      sortable
                      style={{ width: '15%' }}
                    />
                  )}
                  {visibleColumns.startDate && (
                    <Column field="startDate" header="Start Date" />
                  )}
                  {visibleColumns.endDate && (
                    <Column field="endDate" header="End Date" />
                  )}
                  {visibleColumns.renewalDate && (
                    <Column field="renewalDate" header="Renewal Date" />
                  )}
                  {visibleColumns.vendorName && (
                    <Column
                      field="vendorName"
                      header="Vendor"
                      style={{ width: '10%', textAlign: 'center', color: 'black' }}
                      body={(rowData) => (
                        <span style={{ display: 'block', textAlign: 'center', color: 'black' }}>
                          {rowData.type === "Vendor" ? rowData.vendorName : "N/A"}
                        </span>
                      )}
                    />
                  )}


                  {visibleColumns.createdDate && <Column field="createdDate" header="Created" />}
                  {visibleColumns.status && <Column field="status" header="Status" />}
                  {visibleColumns.modified && <Column field="modified" header="Modified" />}
                  {showFlatView && visibleColumns.contractType && <Column field="contractType" header="Contract Type" />}
                  {showFlatView && visibleColumns.creationType && <Column field="creationType" header="Creation Type" />}
                </DataTable>
              </>
            ) : (
              <TreeTable
                value={nodes}

                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 20, 50]}
                expandedKeys={expandedKeys}
                onToggle={(e) => setExpandedKeys(e.value)}
                showGridlines
                globalFilter={filters.global}
                globalFilterFields={['data.name']}
                filterFunction={(node, filter) => globalFilterFunction(node, filter)}
                tableStyle={{ width: "100%", tableLayout: "fixed" }}
                emptyMessage={"No contracts found. Click ‘New’ to create one. ✅"}
                rowClassName={(node) => {
                  if (
                    node.data.type === "Folder" &&
                    node.data.name.includes("Master_Agreements")
                  ) {
                    return "highlight-row";
                  }
                  return "";
                }}
              >
                {visibleColumns.name && (
                  <Column
                    field="name"
                    header="Contracts"
                    style={{ width: "25%", color: "black" }}
                    body={(node) => {
                      const isFolder = node.data?.type === "Folder";
                      const isExpanded = !!expandedKeys[node.key];
                      const contractName = node.data.name || "Unnamed Contract";

                      return (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            paddingLeft: `${node.level * 30}px`,
                            color: "black",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={contractName}
                        >
                          {node.children && node.data?.type === "Folder" && (
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                setExpandedKeys((prev) => {
                                  const newKeys = { ...prev };
                                  if (newKeys[node.key]) {
                                    delete newKeys[node.key];
                                  } else {
                                    newKeys[node.key] = true;
                                  }
                                  return newKeys;
                                });
                              }}
                              style={{
                                display: "inline-flex",
                                width: "18px",
                                height: "18px",
                                background: "white",
                                color: "#ff6b35",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                lineHeight: "18px",
                                verticalAlign: "middle",
                                fontSize: "18px",
                                marginLeft: "5px",
                              }}
                              title="Click to expand/collapse"
                            >
                              {isExpanded ? "−" : "+"}
                            </span>
                          )}

                          {isFolder ? (
                            <span
                              style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                              title={node.key?.startsWith('YEAR-') ? `You can see the ${node.data.name} year contracts under me` : contractName}
                            >
                              📂 {contractName}
                            </span>
                          ) : (
                            <span
                              style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                              title={contractName}
                            >
                              📄{" "}
                              <a
                                href={node.data.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#1976d2", textDecoration: "none" }}
                                title="Click to open the document"
                              >
                                {contractName}
                              </a>
                            </span>
                          )}
                        </div>
                      );
                    }}
                  />

                )}

                <Column
                  field="type"
                  header="Type"
                  style={{ width: "15%", textAlign: "center", color: "black" }}
                  body={(node) => {
                    const entityType =
                      node.data.entity_type ||
                      (node.data.clientName?.toLowerCase().includes("vendor") ? "vendor" : "client");

                    const typeLabel = entityType?.toLowerCase() === "vendor" ? "Vendor" : "Client";

                    return (
                      <span
                        style={{
                          display: "block",
                          textAlign: "center",
                          color: "black",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {typeLabel}
                      </span>
                    );
                  }}
                />

                {visibleColumns.createdDate && (
                  <Column
                    field="createdDate"
                    header="Created"
                    style={{ width: "15%", textAlign: "center", color: "black" }}
                    sortable
                    body={(node) => {
                      if (node.key.split("-").length === 1) return null;
                      return (
                        <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {node.data.createdDate}
                        </span>
                      );
                    }}
                  />
                )}
                {visibleColumns.startDate && (
                  <Column
                    field="startDate"
                    header="Start Date"
                    style={{ width: "12%", textAlign: "center", color: "black" }}
                    body={(node) => (
                      node.data.type === "File" ? (
                        <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {node.data.start_date ? String(node.data.start_date) : 'N/A'}
                        </span>
                      ) : null
                    )}
                  />
                )}
                {visibleColumns.endDate && (
                  <Column
                    field="endDate"
                    header="End Date"
                    style={{ width: "12%", textAlign: "center", color: "black" }}
                    body={(node) => (
                      node.data.type === "File" ? (
                        <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {!node.data.end_date ? 'N/A' : (String(node.data.end_date) === '1999-01-01' || String(node.data.end_date).startsWith('1999-01-01')) ? 'Auto renewal' : String(node.data.end_date)}
                        </span>
                      ) : null
                    )}
                  />
                )}
                {visibleColumns.renewalDate && (
                  <Column
                    field="renewalDate"
                    header="Renewal Date"
                    style={{ width: "14%", textAlign: "center", color: "black" }}
                    body={(node) => (
                      node.data.type === "File" ? (
                        <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {!node.data.renewal_date ? 'N/A' : (String(node.data.renewal_date) === '1999-01-01' || String(node.data.renewal_date).startsWith('1999-01-01')) ? 'Auto renewal' : String(node.data.renewal_date)}
                        </span>
                      ) : null
                    )}
                  />
                )}
                {visibleColumns.status && (
                  <Column
                    field="status"
                    header="Status"
                    style={{ width: "15%", textAlign: "center", color: "black" }}
                    body={(node) => {
                      if (node.key.split("-").length === 1 || node.data.type === "Folder") return null;
                      const status = node.data.status || "Trashed";
                      const statusColorMap = {
                        "Active": "#1976D2",
                        "Approved": "#2E7D32",
                        "Archived": "#9C27B0",
                        "Draft": "#ec407a",
                        "Expired": "#C62828",
                        "Pending Approval": "#FBC02D",
                        "Signed": "#009688",
                        "Terminated": "#455A64",
                        "Trashed": "#E64A19",
                        "Moved to Trash": "#E64A19",
                      };

                      const backgroundStyle = {
                        background: statusColorMap[status] || "#616161",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        color: status === "Pending Approval" ? "#333" : "#fff",
                        display: "inline-block",
                        textAlign: "center",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        lineHeight: "1.2",
                        maxWidth: "100%",
                      };
                      return <span style={backgroundStyle}>{status}</span>;
                    }}
                  />
                )}
                {visibleColumns.modified && (
                  <Column
                    field="modified"
                    header="Modified"
                    style={{ width: "15%", textAlign: "center", color: "black" }}
                    sortable
                    body={(node) => {
                      if (node.key.split("-").length === 1) return null;
                      return (
                        <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {node.data.modified}
                        </span>
                      );
                    }}
                  />
                )}
                {visibleColumns.actions && (
                  <Column
                    header="Actions"
                    style={{ width: "15%", textAlign: "center", color: "black" }}
                    body={(node) => {
                      const isFile = node.data?.type === "File";
                      const isNonFirstLevelFolder = node.data?.type === "Folder" && node.key.split("-").length > 1;
                      if (!isFile && !isNonFirstLevelFolder) return null;

                      return (
                        <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                          {isFile && (
                            <>
                              <Info
                                style={{ cursor: "pointer", color: "#ff6b35", width: "16px", height: "16px" }}
                                titleAccess="View Details"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  const cleanId = getCleanContractId(node.data.id);
                                  const clientKey = getClientKey(node.key);
                                  navigate("/categories", { state: { contractId: cleanId, clientKey, fromTreeTable: true } });
                                }}
                              />
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill={node.data.is_favourite ? "#ff6b35" : "none"}
                                stroke="#ff6b35"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="action-image1"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleAddFavourite(node);
                                }}
                                titleAccess={node.data.is_favourite ? "Remove from Favorites" : "Add to Favorites"}
                              >
                                <polygon points="12 2 15 9 22 9 17 14 18 21 12 17 6 21 7 14 2 9 9 9 12 2" />
                              </svg>
                              {hasFullAccess && (
                                <Delete
                                  style={{
                                    cursor: node.data.is_deleted ? "not-allowed" : "pointer",
                                    width: "16px",
                                    height: "16px",
                                    color: "#ff6b35",
                                    fill: node.data.is_deleted ? "#ff6b35" : "",
                                  }}
                                  titleAccess={node.data.is_deleted ? "Already Deleted" : "Move to Archive"}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (!node.data.is_deleted) {
                                      setContractToDelete(node);
                                      setIsDeleteModalOpen(true);
                                    }
                                  }}
                                />
                              )}
                            </>
                          )}
                          {isNonFirstLevelFolder && hasFullAccess && (
                            <Add
                              style={{
                                cursor: "pointer",
                                color: "#ff6b35",
                                width: "16px",
                                height: "16px",
                                display: "inline-flex",
                                visibility: "visible",
                                opacity: 1,
                                fill: "#ff6b35",
                                pointerEvents: "auto",
                                zIndex: 1
                              }}
                              titleAccess="Add New Document"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleAddWithPrefill(node);
                              }}
                            />
                          )}
                        </div>
                      );
                    }}
                  />
                )}

              </TreeTable>
            )}
          </div>

          {showColumnOptions && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.4)",
                backdropFilter: "blur(6px)",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-end",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  width: "340px",
                  background: "#fff",
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginTop: "100px",
                  marginRight: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 12px",
                    fontWeight: "700",
                    background: "#ff6b35",
                    color: "#fff",
                  }}
                >
                  <div>Column Options</div>
                  <button
                    onClick={() => setShowColumnOptions(false)}
                    aria-label="Close"
                    style={{ background: "transparent", border: "none", fontSize: "25px", cursor: "pointer", color: "#fff" }}
                  >
                    ×
                  </button>
                </div>
                <div style={{ maxHeight: "50vh", overflowY: "auto", padding: "10px 12px" }}>
                  {(showFlatView
                    ? ["name", "type", "vendorName", "startDate", "endDate", "renewalDate", "createdDate", "status", "modified", "contractType", "creationType"]
                    : ["name", "type", "startDate", "endDate", "renewalDate", "createdDate", "status", "modified", "actions"]
                  ).map((key) => (
                    <div
                      key={key}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "8px 0",
                        borderBottom: "1px solid #f3f4f6",
                      }}
                    >
                      <span style={{ fontSize: "14px", color: "#111827" }}>
                        {getColumnLabel(key)}
                        {mandatoryColumns.includes(key) ? <span style={{ color: '#ff6b35' }}> *</span> : ''}
                      </span>
                      <button
                        onClick={() => toggleColumn(key)}
                        disabled={mandatoryColumns.includes(key)}
                        aria-label={tempVisibleColumns[key] ? `Hide ${key}` : `Show ${key}`}
                        style={{
                          background: "transparent",
                          border: "none",
                          cursor: mandatoryColumns.includes(key) ? 'not-allowed' : 'pointer',
                          opacity: mandatoryColumns.includes(key) ? 0.6 : 1
                        }}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#000000"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                          {!tempVisibleColumns[key] && (
                            <line x1="2" y1="2" x2="18" y2="18" stroke="#000000" strokeWidth="3" />
                          )}
                        </svg>
                      </button>
                    </div>
                  ))}
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", padding: "10px 12px", borderTop: "1px solid #e5e7eb" }}>

                  <button
                    onClick={() => {
                      setTempVisibleColumns(visibleColumns); // reset staging
                      setShowColumnOptions(false);
                    }}
                    style={{ background: "transparent", color: "#ff6b35", border: "1px solid #ff6b35", padding: "8px 14px", borderRadius: "6px" }}
                  >
                    Cancel
                  </button>


                  <button
                    onClick={() => {
                      const newVisible = { ...tempVisibleColumns };
                      mandatoryColumns.forEach(col => {
                        if (newVisible.hasOwnProperty(col)) newVisible[col] = true;
                      });
                      setVisibleColumns(newVisible);
                      localStorage.setItem('treeTableVisibleColumns', JSON.stringify(newVisible));
                      setShowColumnOptions(false);
                    }}
                    style={{ background: "#ff6b35", color: "#fff", border: "1px solid #ff6b35", padding: "8px 14px", borderRadius: "6px" }}
                  >
                    Save
                  </button>

                </div>
              </div>
            </div>
          )}

          <CreateBlankModal
            isOpen={isModalOpen}
            onClose={() => {
              setIsModalOpen(false);
              setContextMenu({ visible: false, node: null, contractId: null });
            }}
            onSave={async (data, saveCompleted) => {
              console.log(
                "Save initiated",
                modalType,
                "under folder:",
                contextMenu.node?.data?.name,
                "data:",
                data
              );
              setIsModalOpen(false);
              setLoading(true);
              try {
                if (saveCompleted && typeof saveCompleted === "function") {
                  await new Promise((resolve) => saveCompleted(resolve));
                }
                const endpoint = getApiEndpoint();
                const res = await apiService.fetchData(endpoint);
                if (res && res.contract_hierarchy) {
                  const withLevels = addLevels(res.data.contract_hierarchy);
                  setNodes(withLevels);
                }
              } catch (error) {
                console.error("Error refreshing contract hierarchy after save:", error);
                setSnackbar({
                  open: true,
                  success: false,
                  message: "Error refreshing data after save",
                });
              } finally {
                setLoading(false);
              }
            }}
            parentNode={contextMenu.node}
          />

          <AddDocumentModal
            isOpen={isAddDocumentModalOpen}
            onClose={() => {
              setIsAddDocumentModalOpen(false);
              setPrefillContractData(null);
              setIsPrefillLoading(false);
              setContextMenu({ visible: false, node: null, contractId: null });
            }}
            prefillContractData={prefillContractData}
            isPrefillLoading={isPrefillLoading}
            onSelectTemplate={() => {
              console.log("Template selection triggered");
            }}
            onSave={async (data, saveCompleted) => {
              console.log("Save initiated from AddDocumentModal", modalType, "data:", data);
              setIsAddDocumentModalOpen(false);
              setLoading(true);

              try {

                if (saveCompleted && typeof saveCompleted === "function") {
                  await new Promise((resolve) => saveCompleted(resolve));
                }


                const endpoint = getApiEndpoint();
                const response = await apiService.fetchData(endpoint);
                const res = response?.data || response;
                const hierarchyRoot = res?.contract_hierarchy?.[0];
                const hierarchyData = res?.contract_hierarchy ?? [];

                if (Array.isArray(hierarchyData)) {
                  console.log("Fetched updated hierarchy:", hierarchyData);


                  const withLevels = addLevels(hierarchyData);
                  setNodes([...withLevels]);

                  console.log("Hierarchy refreshed successfully");
                  setSnackbar({
                    open: true,
                    success: true,
                    message: "Contracts refreshed successfully",
                  });
                } else {
                  console.error("Hierarchy structure invalid:", res);
                  setSnackbar({
                    open: true,
                    success: false,
                    message: "Hierarchy data missing or invalid",
                  });
                }
              } catch (error) {
                console.error("Error refreshing contract hierarchy after save:", error);
                setSnackbar({
                  open: true,
                  success: false,
                  message: "Error refreshing data after save",
                });
              } finally {
                setLoading(false);
              }
            }}

            parentNode={contextMenu.node}
          />
          {isDeleteModalOpen && (
            <DeleteConfirmationModal
              isOpen={isDeleteModalOpen}
              onClose={() => setIsDeleteModalOpen(false)}
              onConfirm={(reason) => {
                if (contractToDelete) handleTrash(contractToDelete, reason);
              }}
              contractName={contractToDelete?.data?.name}
              isDeleting={isDeleting}
            />
          )}

          <Snackbar
            open={snackbar.open}
            autoHideDuration={5000}
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            message={snackbar.message}
            sx={{
              "& .MuiSnackbarContent-root": {
                backgroundColor: snackbar.success ? "#4caf50" : "#f44336",
              },
              zIndex: 1400,
            }}
          />
        </>
      )}
      <Footer />
    </div>

  );
};

export default TreeTableSample;